<motn-drawer-gap-from-top
  (clickedOutside$)="clickedOutside$.emit($event)"
>
  <div
    class="outer"
  >
    <div
      class="content devices"
    >
      <h3>
        Configure Points
        <motn-pill color="indigo">LoRaWAN</motn-pill>
      </h3>

      @if (!getCurrentSelectedDevice()) {
        <div
          class="fake-select error"
          (click)="onDeviceMenuClick()"
        >
          &nbsp;
        </div>
      }

      @if (getCurrentSelectedDevice()) {
        <div
          class="fake-select"
          (click)="onDeviceMenuClick()"
          [innerText]="$safeNavigationMigration(getCurrentSelectedDevice()?.Name)"
        ></div>
      }

      @if (deviceMenuOptions) {
        <motn-popover-multi-select
          [multiOrSingle]="'single'"
          [optionGroup]="deviceMenuOptions"
          (clickedOutsideMenu$)="onDeviceMenuDone()"
          (clickedOption$)="onDeviceMenuDone(); onDeviceChange();"
        ></motn-popover-multi-select>
      }

      <div class="label">
        Device
        <span
          (click)="infoDevicesMenu()"
        >
          <i class="fa-regular fa-circle-info"></i>
        </span>
      </div>
    </div>

    @if (useCase) {
      <div
        class="content use-case"
      >
        <div class="subtitle">
          View points for
        </div>

        <div class="title">
          {{useCase}}
        </div>
      </div>
    }
  </div>

  <div
    class="outer"
  >
    @if (filteredPoints) {
      <div
        class="content results"
      >
        <h3>
          <div class="text">
            Available Points

            <motn-pill>{{filteredPoints.length}}</motn-pill>

            @if (!selectionMode) {
              <button
                class="small green"
                [disabled]="!getCurrentSelectedDevice()"
                (click)="configurePoint()"
              >
                Add Point
              </button>
            }

            <div class="actions">
              @if (!isMobile() && !selectionMode) {
                <motn-menu-button
                  buttonClass="small"
                  [optionsFactory]="createToolsOptions"
                >
                  Tools
                  <i class="fa-regular fa-chevron-down"></i>
                </motn-menu-button>
              }
            </div>

            <div class="search">
              <input
                class="small"
                placeholder="Search points..."
                [(ngModel)]="searchTerm"
                (ngModelChange)="filterAndRenderPoints()"
              >
            </div>
          </div>
        </h3>

        <motn-sort-table
          [table$]="table$"
        ></motn-sort-table>
      </div>
    }
  </div>
</motn-drawer-gap-from-top>

@if (editingPoint !== undefined) {
  <motn-lorawan-single-point
    [point]="editingPoint"
    [deviceId]="selectedDevice"
    (clickedOutside$)="editingPoint = undefined"
    (saved$)="onPointSaved()"
  ></motn-lorawan-single-point>
}

@if (editingTile) {
  <motn-tile-editor
    [tileId]="editingTile"
    (closed$)="editingTile = null"
    (deleted$)="editingTile = null"
  ></motn-tile-editor>
}
